import type { FC } from 'react'

class KeyValue {
    [key: string]: string
}

export class BasePagesEnum extends KeyValue {
    ErrorNotFound = 'ErrorNotFound'
}

export abstract class BaseSubPageKey<T extends BasePagesEnum> {
    public abstract parent: keyof T
}

export type BasePageOrSubPage = BasePagesEnum | BaseSubPageKey<BasePagesEnum>

export type PageOrSubPage<PagesEnum extends BasePagesEnum, SubPageKey extends BaseSubPageKey<PagesEnum>> =
    | PagesEnum
    | SubPageKey

export type PageOrSubPageKey<PagesEnum extends BasePagesEnum, SubPageKey extends BaseSubPageKey<PagesEnum>> =
    | keyof PagesEnum
    | keyof SubPageKey

export type PageList<PagesEnum extends BasePagesEnum, SubPageKey extends BaseSubPageKey<PagesEnum>> = {
    [key in keyof PagesEnum]: PageDetails<PagesEnum, SubPageKey>
}

export interface SubPageDetails<SubPageKey> {
    urls: string[] | undefined
    alias?: keyof SubPageKey
    params?: string[]
    component: FC<unknown>
}

export interface PageDetails<PagesEnum extends BasePagesEnum, SubPageKey> extends SubPageDetails<SubPageKey> {
    parent?: keyof PagesEnum
    customAlias?: string
    subPages?: Array<SubPageDetails<SubPageKey>>
}
